export default __webpack_public_path__ + "static/media/logo.2ad14b04.svg";